function normalizeSearchValue(value) {
  return (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/ς/g, 'σ')
    .trim();
}

function readStoredPlaces(storageKey) {
  try {
    var places = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
    return Array.isArray(places) ? places : [];
  } catch (_error) {
    return [];
  }
}

function rememberPlace(location) {
  if (!location || !location.id || !location.name || !location.url) {
    return;
  }

  try {
    var storageKey = 'kairos.recentPlaces.v1';
    var recent = readStoredPlaces(storageKey).filter(function (place) {
      return String(place.id) !== String(location.id);
    });

    recent.push({ id: location.id, name: location.name, url: location.url });
    window.localStorage.setItem(storageKey, JSON.stringify(recent.slice(-5)));
  } catch (_error) {}
}

function distanceBetween(latitude, longitude, location) {
  var radians = Math.PI / 180;
  var lat1 = latitude * radians;
  var lat2 = Number(location.lat) * radians;
  var deltaLat = (Number(location.lat) - latitude) * radians;
  var deltaLng = (Number(location.lng) - longitude) * radians;
  var a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);

  return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function initializeNationalTomorrow() {
  var page = document.querySelector('[data-national-tomorrow]');
  if (!page || page.getAttribute('data-location-ui-initialized') === 'true') {
    return;
  }

  page.setAttribute('data-location-ui-initialized', 'true');

  var searchForm = page.querySelector('[data-tomorrow-search]');
  var searchInput = searchForm && searchForm.querySelector('input[name="term"]');
  var searchDatalist = page.querySelector('#national-tomorrow-locations');
  var autocompleteUrlNode = document.querySelector('meta[name="places-autocomplete-url"]');
  var searchSuggestionsPromise = null;

  function loadSearchSuggestions() {
    if (searchSuggestionsPromise || !searchDatalist || !autocompleteUrlNode) {
      return searchSuggestionsPromise;
    }

    searchSuggestionsPromise = window.fetch(autocompleteUrlNode.content, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Search suggestions unavailable');
      }
      return response.json();
    }).then(function (terms) {
      var seen = {};
      var fragment = document.createDocumentFragment();

      (Array.isArray(terms) ? terms : []).forEach(function (term) {
        if (!term || term.type !== 'place') {
          return;
        }

        var value = (term.value || term.label || '').toString().trim();
        var normalizedValue = normalizeSearchValue(value);
        if (!value || seen[normalizedValue]) {
          return;
        }

        seen[normalizedValue] = true;
        var option = document.createElement('option');
        option.value = value;
        fragment.appendChild(option);
      });

      searchDatalist.appendChild(fragment);
      return true;
    }).catch(function () {
      searchSuggestionsPromise = null;
      return false;
    });

    return searchSuggestionsPromise;
  }

  if (searchInput) {
    searchInput.addEventListener('focus', loadSearchSuggestions, { once: true });
  }

  var savedSection = page.querySelector('[data-tomorrow-saved]');
  var savedList = page.querySelector('[data-tomorrow-saved-list]');
  var seenIds = {};
  var storedPlaces = readStoredPlaces('kairos.favoritePlaces.v1')
    .concat(readStoredPlaces('kairos.recentPlaces.v1').reverse())
    .filter(function (storedPlace) {
      var id = String(storedPlace && storedPlace.id);
      if (!storedPlace || !storedPlace.name || !storedPlace.url || !id || seenIds[id]) {
        return false;
      }

      seenIds[id] = true;
      return true;
    })
    .slice(0, 5);

  storedPlaces.forEach(function (storedPlace) {
    var item = document.createElement('li');
    var link = document.createElement('a');
    var tomorrowPathTemplate = page.getAttribute('data-tomorrow-path-template') || '/__SLUG__/kairos-avrio';
    var storedUrl = new URL(storedPlace.url, window.location.origin);
    var pathSegments = storedUrl.pathname.split('/').filter(Boolean);
    var slug = pathSegments[pathSegments.length - 1];
    link.href = slug ? tomorrowPathTemplate.replace('__SLUG__', slug) : storedPlace.url;
    link.textContent = storedPlace.name;
    link.setAttribute('data-tomorrow-location-id', storedPlace.id);
    item.appendChild(link);
    savedList.appendChild(item);
  });

  if (savedSection && storedPlaces.length) {
    savedSection.hidden = false;
  }

  var geolocateButton = page.querySelector('[data-tomorrow-geolocate]');
  var status = page.querySelector('[data-tomorrow-location-status]');
  var result = page.querySelector('[data-tomorrow-location-result]');
  var resultName = page.querySelector('[data-tomorrow-location-name]');
  var resultLink = page.querySelector('[data-tomorrow-location-link]');
  var locationDataPromise = null;

  function loadLocationData() {
    if (locationDataPromise) {
      return locationDataPromise;
    }

    var locationDataUrl = page.getAttribute('data-location-data-url');
    if (!locationDataUrl) {
      return Promise.resolve([]);
    }

    locationDataPromise = window.fetch(locationDataUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Location data unavailable');
      }
      return response.json();
    }).then(function (locations) {
      return Array.isArray(locations) ? locations : [];
    }).catch(function () {
      locationDataPromise = null;
      return [];
    });

    return locationDataPromise;
  }

  if (!geolocateButton) {
    return;
  }

  geolocateButton.addEventListener('click', function () {
    result.hidden = true;

    if (!navigator.geolocation) {
      status.textContent = page.getAttribute('data-location-unavailable-text');
      return;
    }

    geolocateButton.disabled = true;
    status.textContent = page.getAttribute('data-locating-text');

    navigator.geolocation.getCurrentPosition(function (position) {
      loadLocationData().then(function (locations) {
        var candidates = locations.filter(function (location) {
          return Number.isFinite(Number(location.lat)) && Number.isFinite(Number(location.lng));
        });
        var nearest = candidates.reduce(function (closest, location) {
          var distance = distanceBetween(position.coords.latitude, position.coords.longitude, location);
          return !closest || distance < closest.distance ? { location: location, distance: distance } : closest;
        }, null);

        geolocateButton.disabled = false;
        if (!nearest) {
          status.textContent = page.getAttribute('data-location-unavailable-text');
          return;
        }

        var location = nearest.location;
        status.textContent = page.getAttribute('data-location-found-text');
        resultName.textContent = location.name;
        resultLink.href = location.url;
        resultLink.textContent = page.getAttribute('data-location-cta-template').replace('__LOCATION__', location.name);
        resultLink.onclick = function () { rememberPlace(location); };
        result.hidden = false;
      });
    }, function () {
      geolocateButton.disabled = false;
      status.textContent = page.getAttribute('data-location-denied-text');
    }, {
      enableHighAccuracy: false,
      maximumAge: 600000,
      timeout: 8000
    });
  });
}

document.addEventListener('turbolinks:load', initializeNationalTomorrow);
document.addEventListener('DOMContentLoaded', initializeNationalTomorrow);
